import { Inertia } from '@inertiajs/inertia'
import { FunctionalComponent, h } from '@stencil/core'
import { InertiaLink } from 'src/inertia/link/link'
import { ExternalLink, getCompanyUrl } from 'src/utils/url'

import { ICallChip, ICompany } from '../types'

export const CompanyLink: FunctionalComponent<{ company: ICompany }> = ({ company }, children) => {
  return company?.teamCompanyViewUrl ? (
    <InertiaLink
      href={company.teamCompanyViewUrl}
      onClick={(e) => {
        e.stopImmediatePropagation()
        Inertia.visit(company.teamCompanyViewUrl)
      }}
    >
      {children}
    </InertiaLink>
  ) : company?.domain ? (
    <ExternalLink href={getCompanyUrl(company)}>{children}</ExternalLink>
  ) : (
    children
  )
}

export const CallCompanyLink: FunctionalComponent<{ call: ICallChip }> = ({ call }, children) => {
  return <CompanyLink company={call.company}>{children}</CompanyLink>
}
